// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "fieldset[data-v-6f32e903] {\n  margin: 1rem 5px;\n  border-radius: 8px;\n}\nfieldset legend[data-v-6f32e903] {\n  margin-left: 7px;\n  padding: 0 5px;\n  font-weight: bold;\n}\nfieldset > div:first-of-type > div[data-v-6f32e903] {\n  margin-right: 0 !important;\n  height: 1rem;\n}", ""]);
// Exports
module.exports = exports;
